import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: ".drag-handle, .sub-drag-handle",
      animation: 150,
      draggable: ".root-category, .sub-category",
      onStart: (event) => {
        const isRoot = event.item.classList.contains("root-category")
        if (isRoot) {
          // Collapse all sub-categories and accordion rows during root reordering for clean visual flow
          this.element.querySelectorAll(".sub-category, .sub-accordion-row").forEach(el => {
            el.style.display = "none"
          })
        }
      },
      onMove: (evt) => {
        const dragged = evt.dragged
        const related = evt.related

        if (dragged.classList.contains("sub-category")) {
          // Sub-category can only be dropped next to another sub-category with the same parent_id
          if (!related.classList.contains("sub-category")) return false
          if (dragged.dataset.parentId !== related.dataset.parentId) return false
        }
        return true
      },
      onEnd: (event) => {
        const isSub = event.item.classList.contains("sub-category")
        if (isSub) {
          this.reorderSub(event)
        } else {
          this.reorderRoot(event)
        }
      }
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  reorderSub(event) {
    const categoryId = event.item.dataset.categoryId
    const parentId = event.item.dataset.parentId
    const siblings = Array.from(this.element.querySelectorAll(`.sub-category[data-parent-id="${parentId}"]`))
    const position = siblings.indexOf(event.item) + 1
    this.submitReorder(categoryId, position)
  }

  reorderRoot(event) {
    const categoryId = event.item.dataset.categoryId
    const roots = Array.from(this.element.querySelectorAll(".root-category"))
    const position = roots.indexOf(event.item) + 1
    this.submitReorder(categoryId, position)
  }

  submitReorder(categoryId, position) {
    const locale = new URLSearchParams(window.location.search).get("locale") || ""
    const localeParam = locale ? `?locale=${locale}` : ""

    fetch(`/categories/${categoryId}/reorder${localeParam}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify({ position })
    })
      .then(response => response.text())
      .then(html => {
        if (html) {
          Turbo.renderStreamMessage(html)
        } else {
          this.restoreSubCategories()
        }
      })
      .catch(() => {
        this.restoreSubCategories()
      })
  }

  restoreSubCategories() {
    this.element.querySelectorAll(".sub-category, .sub-accordion-row").forEach(el => {
      el.style.display = ""
    })
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').content
  }
}
